import React, { useState } from "react";
import { STATUS } from "../../../../../constants";
import { downloadReferralLetter, fetchReferralLetter } from "../../../../../services/referralLetters";

const { LOADING, DEFAULT, SUCCEED, FAILED } = STATUS;
const isDataFromPMS = process.env.REACT_APP_DATA_SOURCE === "pms-api";

const ActionPanel = ({
  status,
  handleSave,
  handleUploadTheTestResult,
  handleDeleteReferral,
  handleUploadReferral,
  referral,
  source,
}) => {
  const [downloadStatus, setDownloadStatus] = useState({ status: DEFAULT });
  const handleDownloadReferralLetter = async (e) => {
    setDownloadStatus({ status: LOADING });
    e.preventDefault();
    const id = isDataFromPMS ? referral?.letterFile?.name : referral?.letterFile?.id; // It is file name in gcs /ai-ocr-referral/<file_name> actually
    if (id) {
      try {
        const res = await fetchReferralLetter(id, source);
        downloadReferralLetter([res.data], id);
        setDownloadStatus({ status: SUCCEED });
      } catch (e) {
        setDownloadStatus({ status: FAILED, error: "Fail to download referral letter" });
      }
    } else {
      setDownloadStatus({ status: FAILED, error: "Referral letter id is not exist." });
    }
  };
  return (
    <>
      <div className="buttons">
        <button
          className={`button is-small is-radiusless is-primary${status === LOADING ? " is-loading" : ""}`}
          onClick={handleSave}
        >
          {isDataFromPMS ? "Save into pms" : "Save into coreplus"}
        </button>
        <button
          className={`button is-small is-radiusless is-info is-light${status === LOADING ? " is-loading" : ""}`}
          onClick={handleUploadTheTestResult}
        >
          Upload patient info
        </button>
        <button
          className={`button is-small is-radiusless is-danger is-light${status === LOADING ? " is-loading" : ""}`}
          onClick={handleDeleteReferral}
        >
          Delete
        </button>
        <button
          className={`button is-small is-radiusless is-success is-light${
            downloadStatus.status === LOADING ? " is-loading" : ""
          }`}
          onClick={handleDownloadReferralLetter}
        >
          Download referral letter
        </button>
        <button
          className={`button is-small is-radiusless is-light${status === LOADING ? " is-loading" : ""}`}
          onClick={handleUploadReferral}
        >
          Create R workflow
        </button>
      </div>
      {downloadStatus.status === FAILED && (
        <article className="message is-danger">
          <div className="message-body">{downloadStatus.error}</div>
        </article>
      )}
    </>
  );
};

export default ActionPanel;
